import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
const HistoricalCollapseIcon = ({ isOpen }) => {
  return (
    <>
      {isOpen ? (
        <KeyboardArrowDownIcon className="icon-arrow" />
      ) : (
        <ChevronRightIcon className="icon-arrow" />
      )}
    </>
  )
}

export default HistoricalCollapseIcon
